import React from 'react';
import { observer } from 'mobx-react';
import { BaasicModal, YesNoView } from 'core/components';

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
	},
};

function BaasicConfirmModalTemplate({ modalParams, ...rest }) {
	return (
		<BaasicModal modalParams={modalParams}>
			<YesNoView
				message={modalParams.message}
				onConfirm={modalParams.onConfirm}
				onCancel={modalParams.onCancel}
				yesLabel={modalParams.yesLabel}
				noLabel={modalParams.noLabel}
				{...rest}
			/>
		</BaasicModal>
	);
}

export default observer(BaasicConfirmModalTemplate);
